import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import BlockIcon from "@mui/icons-material/Block";

const STATUS_CONFIG = {
  COMPLETED: { label: "Completed", color: "success", icon: <CheckCircleIcon /> },
  PENDING: { label: "Calculating…", color: "warning", icon: <HourglassEmptyIcon /> },
  SENDING: { label: "Calculating…", color: "warning", icon: <HourglassEmptyIcon /> },
  RETRY: { label: "Calculating…", color: "warning", icon: <HourglassEmptyIcon /> },
  FAILED: { label: "Failed", color: "error", icon: <ErrorIcon /> },
  REJECTED_UNSUPPORTED: { label: "Not Available", color: "default", icon: <BlockIcon /> },
};

// Status badge for a HolosCalculationJobRecord's `status` field. PENDING/SENDING/RETRY
// are collapsed into one user-facing "Calculating…" label -- the raw enum is only
// surfaced in the tooltip, since the distinction between them isn't meaningful to a grower.
export default function HolosStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: status || "Unknown",
    color: "default",
    icon: null,
  };

  return (
    <Tooltip title={status || ""}>
      <Chip
        size="small"
        label={config.label}
        color={config.color}
        icon={config.icon}
        variant="outlined"
      />
    </Tooltip>
  );
}
